import { makeActionCreator } from '../../../../../utilities'
import { PulsesConstants } from './pulses.constants'

export const setPulseCarotid = makeActionCreator(PulsesConstants.SET_PULSECAROTID, 'pulseCarotid')
export const setPulseRadL = makeActionCreator(PulsesConstants.SET_PULSERADL, 'pulseRadL')
export const setPulseBraL = makeActionCreator(PulsesConstants.SET_PULSEBRAL, 'pulseBraL')
export const setPulseFemL = makeActionCreator(PulsesConstants.SET_PULSEFEML, 'pulseFemL')
export const setPulseDorsL = makeActionCreator(PulsesConstants.SET_PULSEDORSL, 'pulseDorsL')
export const setPulseCarotidR = makeActionCreator(PulsesConstants.SET_PULSECAROTIDR, 'pulseCarotidR')
export const setPulseRadR = makeActionCreator(PulsesConstants.SET_PULSERADR, 'pulseRadR')
export const setPulseBraR = makeActionCreator(PulsesConstants.SET_PULSEBRAR, 'pulseBraR')
export const setPulseFemR = makeActionCreator(PulsesConstants.SET_PULSEFEMR, 'pulseFemR')
export const setPulseDorsR = makeActionCreator(PulsesConstants.SET_PULSEDORSR, 'pulseDorsR')

export const setResponse = makeActionCreator(PulsesConstants.SET_RESPONSE, 'response')
export const savePulses = makeActionCreator(PulsesConstants.SAVE_PULSES)
export const resetPulsesState = makeActionCreator(PulsesConstants.RESET_STATE)
export const setPulses = makeActionCreator(PulsesConstants.SET_PULSES, 'pulses')
